var map = {
	"./amplify-amazon-button_5.entry.js": [
		384,
		4
	],
	"./amplify-auth-fields_9.entry.js": [
		385,
		9
	],
	"./amplify-authenticator.entry.js": [
		386,
		13
	],
	"./amplify-button_3.entry.js": [
		387,
		10
	],
	"./amplify-checkbox.entry.js": [
		388,
		18
	],
	"./amplify-confirm-sign-in_8.entry.js": [
		389,
		5
	],
	"./amplify-federated-buttons_2.entry.js": [
		390,
		11
	],
	"./amplify-federated-sign-in.entry.js": [
		391,
		14
	],
	"./amplify-form-field_4.entry.js": [
		392,
		19
	],
	"./amplify-greetings.entry.js": [
		393,
		12
	],
	"./amplify-icon-button.entry.js": [
		394,
		20
	],
	"./amplify-icon.entry.js": [
		395,
		15
	],
	"./amplify-link.entry.js": [
		396,
		21
	],
	"./amplify-nav_2.entry.js": [
		397,
		6
	],
	"./amplify-radio-button_2.entry.js": [
		398,
		7
	],
	"./amplify-select-mfa-type.entry.js": [
		399,
		8
	],
	"./amplify-sign-in-button.entry.js": [
		400,
		16
	],
	"./amplify-tooltip.entry.js": [
		401,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 370;
module.exports = webpackAsyncContext;